import { render } from "./LbrxKioskFourthTheme.vue?vue&type=template&id=5db7f97f&scoped=true"
import script from "./LbrxKioskFourthTheme.vue?vue&type=script&lang=js"
export * from "./LbrxKioskFourthTheme.vue?vue&type=script&lang=js"

import "./LbrxKioskFourthTheme.vue?vue&type=style&index=0&id=5db7f97f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5db7f97f"]])

export default __exports__